import {useTranslation} from 'react-i18next';
import './QrComponent.scss';
import {fetchArrivalQrCodeBooking, fetchArrivalQrCodeDropin} from 'src/services/api/api';

type Target = 'booking' | 'dropin';
type QrComponentProps = {
    target: Target;
    clinicId: number;
    canOpenModalFlow: boolean;
    expectedWait?: number;
    onAction: VoidFunction;
};

export function QrComponent({target, clinicId, canOpenModalFlow, expectedWait, onAction}: QrComponentProps) {
    const {t} = useTranslation();

    if (!canOpenModalFlow)
        onAction = () => {
            return false;
        };

    const altText: string = 'qr.' + target;
    const qrSrc = target == 'booking' ? fetchArrivalQrCodeBooking(clinicId) : fetchArrivalQrCodeDropin(clinicId);

    let qr_img;
    let expected_wait;
    if (target == 'dropin') {
        qr_img = (
            <div className='qr-component__img'>
                <img src='/qrscancode.svg' width='200' height='200' alt='Scan a QR code' />
            </div>
        );
        if (expectedWait !== undefined) {
            expected_wait = (
                <>
                    {t('arrival.expected_wait')}: <b>{expectedWait > 0 ? expectedWait : 1} min</b>
                </>
            );
        }
    }

    return (
        <div className='qr-component'>
            <h2 className='qr-component__heading'>{t(`arrival.` + target + `_header`)}</h2>

            <div className='qr-component__code'>
                <img src={qrSrc} alt={altText} />
            </div>
            <div className='qr-component__wait'>{expected_wait}</div>

            <button
                onClick={onAction}
                className='qr-component__actions'
                style={{cursor: canOpenModalFlow ? 'cursor' : 'default'}}
            >
                <p>{t(`arrival.` + target)}</p>
                <p>{canOpenModalFlow ? t(`arrival.continue_link`) : t(`arrival.contact_staff`)}</p>
            </button>
            {qr_img}
        </div>
    );
}
